<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="pl-12 pr-12 col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right">
            <v-btn
              color="#1B437C"
              depressed
              dark
              @click=";(dialogAdd = true), validate('ADD')"
            >
              <v-icon left>mdi-plus-box-multiple</v-icon>
              Add Activity
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-dialog v-model="dialogAdd" persistent max-width="60%">
              <v-card elevation="2" outlined>
                <v-container>
                  <v-card-title>
                    <span class="text-h6">จัดการ Api สำหรับแจก Coin</span>
                  </v-card-title>
                  <v-form ref="form_add" v-model="validAdd" lazy-validation>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            placeholder="API ที่จะนำมาทดสอบ"
                            v-model="urlApi"
                            :rules="[rules.required]"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12">
                          <v-alert dense border="left" type="success">
                            Schema ที่ระบบต้องการ :
                            <strong>{{ dataBetask.toString() }}</strong>
                          </v-alert>
                        </v-col>
                        <v-col cols="12">
                          <v-alert dense border="left" type="info">
                            Schema ที่ระบบคุณมี :
                            <strong>{{ dataApi.toString() }}</strong>
                          </v-alert>
                        </v-col>
                        <v-col cols="12" v-if="dataMerge.length > 0">
                          <v-data-table
                            :headers="columnsMerge"
                            :items="dataMerge"
                            :items-per-page="10"
                          >
                            <template v-slot:[`item.color`]="{ item }">
                              <v-chip
                                class="ma-2"
                                color="success"
                                v-if="item.color == 'green'"
                              >
                                <v-icon left>
                                  mdi-server-plus
                                </v-icon>
                                เข้ากัน
                              </v-chip>
                              <v-chip
                                class="ma-2"
                                color="error"
                                v-if="item.color == 'red'"
                              >
                                <v-icon left>
                                  mdi-close-network
                                </v-icon>
                                ไม่เข้าเข้ากัน
                              </v-chip>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-form>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn elevation="2" x-large @click="dialogAdd = false" dark class="btn-color" >
                      <v-icon left>mdi-cancel</v-icon>
                      ปิด
                    </v-btn>
                    <v-btn
                      elevation="2"
                      x-large
                      color="success"
                      :disabled="!validUpdate"
                      @click="sendApi()"
                      v-if="!showSave"
                    >
                      <v-icon left>mdi-cloud-upload</v-icon>
                      ส่ง
                    </v-btn>
                    <v-btn
                      elevation="2"
                      x-large
                      color="success"
                      @click="insertData()"
                      v-if="showSave"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      บันทึก API
                    </v-btn>
                  </v-card-actions>
                </v-container>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogUpdate" persistent max-width="60%">
              <v-card elevation="2" outlined>
                <v-container>
                  <v-card-title>
                    <span class="text-h6">จัดการ Api สำหรับแจก Coin</span>
                  </v-card-title>
                  <v-form
                    ref="form_update"
                    v-model="validUpdate"
                    lazy-validation
                  >
                    <v-card-text>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            placeholder="API ที่จะนำมาทดสอบ"
                            v-model="urlApi"
                            :rules="[rules.required]"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12">
                          <v-alert dense border="left" type="success">
                            Schema ที่ระบบต้องการ :
                            <strong>{{ dataBetask.toString() }}</strong>
                          </v-alert>
                        </v-col>
                        <v-col cols="12">
                          <v-alert dense border="left" type="info">
                            Schema ที่ระบบคุณมี :
                            <strong>{{ dataApi.toString() }}</strong>
                          </v-alert>
                        </v-col>
                        <v-col cols="12" v-if="dataMerge.length > 0">
                          <v-data-table
                            :headers="columnsMerge"
                            :items="dataMerge"
                            :items-per-page="10"
                          >
                            <template v-slot:[`item.color`]="{ item }">
                              <v-chip
                                class="ma-2"
                                color="success"
                                v-if="item.color == 'green'"
                              >
                                <v-icon left>
                                  mdi-server-plus
                                </v-icon>
                                เข้ากัน
                              </v-chip>
                              <v-chip
                                class="ma-2"
                                color="error"
                                v-if="item.color == 'red'"
                              >
                                <v-icon left>
                                  mdi-close-network
                                </v-icon>
                                ไม่เข้าเข้ากัน
                              </v-chip>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-form>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn elevation="2" x-large @click="dialogUpdate = false" class="btn-color">
                      <v-icon left>mdi-cancel</v-icon>
                      ปิด
                    </v-btn>
                    <v-btn
                      elevation="2"
                      x-large
                      color="success"
                      :disabled="!validUpdate"
                      @click="sendApi()"
                      v-if="!showSave"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      ส่ง
                    </v-btn>
                    <v-btn
                      elevation="2"
                      x-large
                      color="success"
                      @click="editData()"
                      v-if="showSave"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      แก้ไข API
                    </v-btn>
                  </v-card-actions>
                </v-container>
              </v-card>
            </v-dialog>
          </v-col>
          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  dense
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                  dense
                >
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ thaiFormattedDate(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ thaiFormattedDate(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <!-- <v-btn
                      color="green"
                      fab
                      small
                      @click.stop="
                          sendData(item)
                      "
                    >
                      <v-icon dark> mdi-send-circle </v-icon>
                    </v-btn> -->
                    <v-btn
                      class="btn-color"
                      fab
                      dark
                      small
                      @click.stop="
                        ;(dialogUpdate = true),
                          getDataById(item),
                          validate('UPDATE')
                      "
                    >
                      <v-icon dark> mdi-tools </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  data () {
    return {
      session: this.$session.getAll(),
      path: '/givePointApi/',
      dialogAdd: false,
      dialogUpdate: false,
      searchAll2: '',
      rules: {
        required: value => !!value || 'กรุณากรอก.'
      },
      returnLink: '/system/ManageApi',
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'จัดการ Api',
          disabled: false,
          href: '/System/ManageApi'
        }
      ],
      columns: [
        { text: 'Id', value: 'id', align: 'left' },
        { text: 'Url Api', value: 'urlApi', align: 'left' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE', align: 'center' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE', align: 'center' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      columnsMerge: [
        { text: 'Schema', value: 'text' },
        { text: 'Merge', value: 'color' }
      ],
      formUpdate: {},
      validUpdate: true,
      validAdd: true,
      urlApi: '',
      pkId: '',
      dataBetask: [
        'date_input',
        'order_No',
        'branch',
        'service',
        'amount',
        'refId'
      ],
      dataApi: [],
      dataMerge: [],
      showSave: false
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // this.validate('UPDATE')
    this.dataReady = false
    // Get Data
    await this.getDataGlobal(
      this.DNS_IP,
      this.path,
      this.session.data.shopId,
      this.returnLink
    )
  },
  methods: {
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async sendApi () {
      this.showSave = false
      this.dataApi = []
      this.dataMerge = []
      await axios
        .get(this.urlApi)
        .then(async response => {
          let rs = response.data
          console.log(Object.keys(rs[0]))
          this.dataApi = Object.keys(rs[0])
          // this.dataApi = this.dataBetask
          //   this.dataApi = ['date_input', 'order_No', 'branch', 'service', 'amount']
          console.log(this.dataBetask)
          var useData = []
          for (var i = 0; i < this.dataBetask.length; i++) {
            var d = this.dataBetask[i]
            var s = {}
            var chkArr = this.dataApi.filter(function (val) {
              return d === val
            })
            var colors = ''
            if (chkArr.length > '') {
              colors = 'green'
            } else {
              colors = 'red'
            }
            s.color = colors
            s.text = d
            useData.push(s)
          }
          var checkData = useData.filter(function (val) {
            return val.color === 'red'
          })
          this.dataMerge = useData
          if (checkData.length > 0) {
            this.$swal('ผิดพลาด', 'เนื่องจากมี schema ที่ไม่ตรงกัน', 'error')
            this.showSave = false
          } else {
            this.showSave = true
          }
          console.log(useData)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          //   this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
          this.$swal('ผิดพลาด', 'กรุณาตรวจสอบ Api ของท่าน', 'error')
          console.log(error)
        })
    },
    insertData () {
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          var dt = {
            shopId: this.session.data.shopId,
            urlApi: this.urlApi,
            CREATE_USER: this.session.data.userName,
            LAST_USER: this.session.data.userName
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + 'add',
              dt
            )
            .then(async response => {
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)

              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              this.dialogAdd = false

              // Load Data
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              console.log('error function addDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              this.dataReady = true
            })
        })
        .catch(error => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    editData () {
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          var dt = {
            shopId: this.session.data.shopId,
            urlApi: this.urlApi,
            // CREATE_USER: this.session.data.userName,
            LAST_USER: this.session.data.userName
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + 'edit/' + this.pkId,
              dt
            )
            .then(async response => {
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              this.dialogUpdate = false

              // Load Data
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              console.log('error function addDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              this.dataReady = true
            })
        })
        .catch(error => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async getDataById (item) {
      console.log(item)
      this.dataReady = false
      await this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        'id',
        item.id,
        this.returnLink
      )
      this.urlApi = this.formUpdate.urlApi
      this.pkId = this.formUpdate.id
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/System/ManageApi.vue